<div class="gallery">
  <ul class="gallery__list">
    @if (isUploadCustomFileAvailable()) {
      <li class="gallery__list-item gallery-upload">
        <label class="gallery-upload__button">
          <i class="icon icon-generate-image-outline"></i>
          <span class="gallery-upload__button-label">
            {{ uploadCustomFileLabel() }}
          </span>

          <input
            type="file"
            class="gallery-upload__button-input"
            accept="image/*"
            [multiple]="false"
            (change)="onUploadCustomFile($event)"
          />
        </label>
      </li>
    }

    @for (image of fileImages(); track $index) {
      <li
        class="gallery__list-item gallery-item"
        [ngClass]="{ active: selectedFileIndex() === $index }"
      >
        <button class="gallery-item__button" (click)="onSelectFile($index)">
          <img
            [src]="image"
            loading="lazy"
            alt="Gallery Item"
            class="gallery-item__content-image"
          />
        </button>
      </li>
    }
  </ul>
</div>
